import { render } from "./Users.vue?vue&type=template&id=36b5309b"
import script from "./Users.vue?vue&type=script&lang=ts"
export * from "./Users.vue?vue&type=script&lang=ts"
script.render = render

export default script